<template>
    <div class="vetting-process">
        <Navbar />
        <div class="my-5 pb-4"></div>
        <div class="container py-5">
            <div class="row pb-5">
                <div class="col-12 col-md-6 text-left pb-5">
                    <h3 class="vp-head font-weight-bolder kova-text pb-4">Talent. Work. Earn. Growth</h3>
                    <p class="">
                        TalentAlt incorporates an intensive process towards onboarding developers, beyond hard-core software skills, our screening procedure, accesses the developer's time and task management,
                        communication and comprehension skills, technical experience, high-end user focus and problem solving ability.
                    </p>
                    <p class="">
                        TalentAlt recruits talented, fast learning developers with commitment to delivering superb jobs and are open to improvement in themselves and their skills. <b>We do not accept all applications.</b>
                        We only accept applicants that can prove they can offer 
                    </p>
                </div>
                <div class="col-12 col-md-6">
                    <div class="vp-land">
                        <div class="kova-circle"></div>
                        <div class="orange-circle"></div>
                        <div class="h-100 w-100">
                            <div class="vp-img"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pb-5">
            <h6 class="vp-head font-weight-bolder text-uppercase kova-text py-4">kovatek's screening process</h6>
            <div class="row pb-5">
                <div class="col-12 col-md-6 text-left">
                    <div class="py-4">
                        <ul class="StepProgress">
                            
                            <li class="StepProgress-item is-done">
                                <div class="pt-1 pb-4">
                                    <h6 class="font-weight-bolder kova-text">Sign up</h6>
                                    <p class="">As a prospective developer on TalentAlt, you begin by signing up and joinin TalentAlt's community on slack.</p>
                                </div>
                            </li>
                            <li class="StepProgress-item numbered current">
                                <div class="pt-1 pb-4">
                                    <h6 class="font-weight-bolder kova-text">Dev Profile Information</h6>
                                    <p class="">
                                        Developers vetting process begin with profile information. At TalentAlt, we collect necessary information on your experience as a developer,
                                        starting with your core tech stack, portfolios, project and product experience, remote and office experience, and how best you describe yourself.
                                    </p>
                                    <p class="">
                                        At the sign-up stage, the developer should write a detailed description of themselves and their experience, state their skill set, their specialty,
                                        tech-stack and an updated portfolio.
                                    </p>
                                </div>
                            </li>
                            <li class="StepProgress-item numbered current">
                                <div class="pt-1 pb-4">
                                    <h6 class="font-weight-bolder kova-text">Sprint project Exercise</h6>
                                    <p class="">
                                        The vetting process continues with an assessment of the developer's skill set via a sprint project.
                                        The project is designed to assess the developer's core tech-stack proficiency, technical ability, code quality, time management, and attention to details.
                                        </p>
                                    <p class="">
                                         The Sprint project exercise is timed with instructions and procedures to carry out. Upon completion of the task, the developer will be required to:
                                         <ul>
                                             <li class="">Create a private repo on git</li>
                                             <li> Push the code to the private repo</li>
                                             <li class="">Host on free server (heroku, netlify etc)</li>
                                             <li class="">Submit the link of the repo and hosting on the vetting profile page.</li>
                                         </ul>
                                    </p>
                                </div>
                            </li>
                            <li class="StepProgress-item numbered current">
                                <div class="pt-1 pb-4">
                                    <h6 class="font-weight-bolder kova-text">Live Interview</h6>
                                    <p class="">
                                        Next, TalentAlt conducts a live interview that evaluates the developers’ English proficiency, code quality, task analysis & understanding ability, and attention to details.
                                    </p>
                                    <p class="">
                                        The live interview is a technical exercise that also verifies the authenticity of the developer's information provided in stage one and sprint project exercise carried out in stage two of the vetting process.
                                    </p>
                                    <p class="">
                                        The expert interviewer will closely review and follow our scoring template to score the developer and the outcome of the interview will be displayed on the developer’s profile page.
                                        Applicants that scale these stages will be verified developers on TalentAlt and their skill score will be used to determine their technical and professional level officially.
                                    </p>
                                    <ul class="">
                                        <li class="">Junior Developer (50%-59%)</li>
                                        <li class="">Intermediate Developer (60%-79%)</li>
                                        <li class="">Senior Developer (80%-100%)</li>
                                    </ul>
                                    <p class="font-weight-bolder mt-3 text-dark">
                                        If a developer scores below 50%, such developer is termed a Beginner. In TalentAlt, we believe in continuous learning and improvement and as such,
                                        Beginners would be provided with learning assistance to aid and boost their skills. After undergoing the learning drills, Beginners can conclude the vetting exercise by completing stages two and three of the process.
                                    </p>
                                </div>
                            </li>
                            <li class="StepProgress-item numbered current">
                                <div class="pt-1 pb-4">
                                    <h6 class="font-weight-bolder kova-text">Learning & Coding Test</h6>
                                    <p class="">
                                        TalentAlt learning workspace will allow its vetted developers access learning materials and carry out coding tests with their various tech stacks. After a coding test has been completed,
                                        the result can be used for review and assessment if carried out under supervision, additionally, an updated and upgraded portfolio can be used to boost developer’s skill score
                                    </p>
                                </div>
                            </li>
                            <li class="StepProgress-item numbered"></li>
                        </ul>
                    </div>
                    <!-- <a-steps :current="current" @change="onChange" direction="vertical">
                        <a-step title="Step 1" description="This is a description." />
                        <a-step title="Step 2" description="This is a description." />
                        <a-step title="Step 3" description="This is a description." />
                    </a-steps> -->
                </div>
                <div class="col-12 col-md-6">
                    <div class="vp-middle">
                        <div class="mb-5">
                            <div class="green-circle"></div>
                            <div class="vp-the-best text-left text-white p-5">
                                <h4 class="font-weight-bolder text-white">Only the Best Developers</h4>
                                <p class="">Top 3-5% are accepted through our vetting process</p>
                                <div class="vp-the-best-img mt-5"></div>
                            </div>
                        </div>
                        <div class="">
                            <div class="kova-green-circle"></div>
                            <div class="vp-tested text-left text-white p-5">
                                <h4 class="font-weight-bolder text-white">Tested on your Behalf</h4>
                                <p class="">We vigorously vet and test every coding Ninja so you don't have to</p>
                                <div class="vp-tested-img mt-5"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <h6 class="vp-head font-weight-bolder text-uppercase kova-text py-4">reviews & ratings</h6>
            <div class="row pb-5">
                <div class="col-12 col-md-6 text-left">
                    <p class="">Getting hired for remote services on TalentAlt is easy once you have been fully verified. But it does not stop there; you must continuously carry out your task with optimum professionalism and maintain good conduct.
                        Your employers will review and rate your work at the end of the task which will be summed up to be your overall rating on TalentAlt. 
                    </p>
                    <h5 class="font-weight-bolder kova-text">Tips to be Outstanding</h5>
                    <ul>
                        <li class="">
                            Excellent track record.
                            <div class="ml-3">
                                <p class="">Good team work</p>
                                <p class="">Proper communication</p>
                            </div>
                        </li>
                        <li class="">Meeting deadlines</li>
                        <li class="">Fast response to messages or update</li>
                        <li class="">Get clarity</li>
                        <li class=""> Communicate any challenges/confusion (DON’T ASSUME)</li>
                        <li class="">Be polite</li>
                        <li class="">Pay attention to details</li>
                    </ul>
                    <p class=""> Every developer is continually assessed, reviewed and rated. Therefore, should demonstrate professionalism.</p>
                </div>
                <div class="col-12 col-md-6">
                    <div class="vp-end">
                        <div class="kova-orange-circle"></div>
                        <div class="vp-reviews-img">
                            <!-- <div class="vp-reviews-img mt-5"></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
 
 
        <GetHired />
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue';
import GetHired from '@/components/GetHired.vue';
import Footer from '@/components/Footer.vue';

export default {
    name: 'vetting-process',
    components: {
        Navbar, Footer, GetHired
    },
    data(){
        return {
            current: 0
        }
    },
    methods: {
        onChange(current) {
            // console.log('onChange:', current);
            this.current = current;
        },
    }
}
</script>

<style scoped>
.kovatek-text{
    color: #20409a;
}
p, li{
    font-size: 12px;
}
.vetting-exercises-num{
    font-size: 20px;
    color: #3BBB88;
}
.vetting-process-img{
    height: 120%;
    width: 100%;
    
}
.vp-head{
    /* text-shadow: 
        -1px 0 #20409a, 0 1px #20409a, 1px 0 #20409a, 0 -1px #20409a, 
        -1px -1px #20409a, 1px 1px #20409a, -1px 1px #20409a, 1px -1px #20409a; */
}
.vp-land{
    margin-top: 10px;
    position: relative;
    height: 300px;
}
.vp-middle{
    position: relative;
    height: 940px;
}
.vp-end{
    position: relative;
    height: 400px;
}
.kova-circle{
    position: absolute;
    left: 50px;
    top: 20px;
    height: 220px;
    width: 220px;
    background-color: #20409a;
    border-radius: 50%;
}
.orange-circle{
    position: absolute;
    top: 170px;
    left: 370px;
    height: 130px;
    width: 130px;
    background-color: #ee5932;
    border-radius: 50%;
}
.green-circle{
    position: absolute;
    top: 30px;
    left: 300px;
    height: 130px;
    width: 130px;
    background-color: #66d162;
    border-radius: 50%;
}
.kova-green-circle{
    position: absolute;
    top: 860px;
    left: 300px;
    height: 130px;
    width: 130px;
    background-color: #4bb38e;
    border-radius: 50%;
}
.kova-orange-circle{
    position: absolute;
    top: 80px;
    left: 80px;
    height: 130px;
    width: 130px;
    background-color: #ee5832;
    border-radius: 50%;
}
.vp-the-best{
    position: absolute;
    top: 80px;
    left: 100px;
    width: 400px;
    height: 400px;
    background-color: #20409a;
    z-index: 2;
    border-radius: 20px;
}
.vp-tested{
    position: absolute;
    top: 540px;
    left: 100px;
    width: 400px;
    height: 400px;
    background-color: #ee5932;
    z-index: 2;
    border-radius: 20px;
}
.vp-img{
    position: absolute;
    left: 120px;
    top: -50px;
    background-image: url('../assets/KOVATEK/IMAGES/vp-img.png');
    z-index:2;
    background-size: cover;
    background-position: right bottom left top;
    background-repeat: no-repeat;
    width: 360px;
    height: 350px;
}
.vp-the-best-img{
    background-image: url('../assets/KOVATEK/IMAGES/image-001.png');
    z-index:2;
    background-size: cover;
    background-position: right bottom left top;
    background-repeat: no-repeat;
    width: 250px;
    height: 150px;
}
.vp-tested-img{
    background-image: url('../assets/KOVATEK/IMAGES/image-002.png');
    z-index:2;
    background-size: cover;
    background-position: right bottom left top;
    background-repeat: no-repeat;
    width: 250px;
    height: 150px;
}
.vp-reviews-img{
    position: absolute;
    background-image: url('../assets/KOVATEK/IMAGES/image-003.png');
    left: 100px;
    z-index:2;
    background-size: cover;
    background-position: right bottom left top;
    background-repeat: no-repeat;
    width: 420px;
    height: 420px;
}
.wrapper {
    width: 330px;
    font-family: 'Helvetica';
    font-size: 14px;
    border: 1px solid #CCC;
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 0;
    left: 15px;
    width: 10px;
    height: 100%;
    border-left: 0px solid #CCC;
}
.StepProgress-item {
    position: relative;
}
.numbered{
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    left: -15px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    left: -37px;
    width: 50px;
    height: 50px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 1.5px solid #20409a;
}
.StepProgress-item.is-done::after {
    content: "✔";
    font-size: 20px;
    padding-top: 10px;
    color: #FFF;
    text-align: center;
    border: 1px solid #20409a;
    background-color: #20409a;
}
.StepProgress-item.current::before {
    border-left: 1.5px solid #20409a;
}
.StepProgress-item.current::after {
    content:'0' counter(list);
    padding-top: 10px;
    width: 50px;
    height: 50px;
    top: -4px;
    left: -40px;
    font-size: 20px;
    text-align: center;
    color: #20409a;
    border: 1px solid #20409a;
    background-color: white;
}
.StepProgress-item > div {
    margin-left: 50px
}
 
@media screen and (max-width: 767px){
    .vetting-process-img{
        display: none;
    }
}
@media screen and (max-width: 500px){
    .ctrl-header{
        font-size: 18px;
    }
.vp-land{
    margin-top: 60px;
    position: relative;
    height: 200px;
}
.vp-middle{
    position: relative;
    height: 900px;
}
.vp-end{
    position: relative;
    height: 300px;
}
.kova-circle{
    position: absolute;
    left: 0;
    top: 20px;
    height: 150px;
    width: 150px;
}
.orange-circle{
    position: absolute;
    top: 120px;
    left: 200px;
    height: 100px;
    width: 100px;
}
.green-circle{
    position: absolute;
    top: 40px;
    left: 160px;
    height: 100px;
    width: 100px;
    background-color: #66d162;
    border-radius: 50%;
}
.kova-green-circle{
    position: absolute;
    top: 830px;
    left: 150px;
    height: 100px;
    width: 100px;
}
.kova-orange-circle{
    position: absolute;
    top: 60px;
    left: 0px;
    height: 100px;
    width: 100px;
}
.vp-the-best{
    position: absolute;
    top: 80px;
    left: 0;
    right:0;
    margin-right: auto;
    margin-left: auto;
    width: 300px;
    height: 350px;
}
.vp-tested{
    position: absolute;
    top: 540px;
    left: 0;
    right:0;
    margin-right: auto;
    margin-left: auto;
    width: 300px;
    height: 350px;
}
.vp-img{
    position: absolute;
    left: 30px;
    right:0;
    margin-right: auto;
    margin-left: auto;
    top: -40px;
    width: 270px;
    height: 270px;
}
.vp-the-best-img{
    width: 200px;
    height: 120px;
}
.vp-tested-img{
    width: 200px;
    height: 120px;
}
.vp-reviews-img{
    position: absolute;
    background-image: url('../assets/KOVATEK/IMAGES/image-003.png');
    left: 0;
    right:0;
    margin-right: auto;
    margin-left: auto;
    z-index:2;
    background-size: cover;
    background-position: right bottom left top;
    background-repeat: no-repeat;
    width: 300px;
    height: 300px;
}
}
</style>